module.exports = __webpack_public_path__ + "img/construction.bee6815c.jpg";